import { render, staticRenderFns } from "./ConfigTheme.vue?vue&type=template&id=3caa2689&scoped=true"
import script from "./ConfigTheme.vue?vue&type=script&lang=js"
export * from "./ConfigTheme.vue?vue&type=script&lang=js"
import style0 from "./ConfigTheme.vue?vue&type=style&index=0&id=3caa2689&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caa2689",
  null
  
)

export default component.exports